import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../api";

const KINDS = ["Hospital", "Convênio / operadora", "Clínica", "Prefeitura / órgão público", "Empresa", "Particular"];
const empty = () => ({ name: "", kind: KINDS[0], doc: "", email: "", phone: "", cep: "", street: "", number: "", complement: "", district: "", city: "", uf: "", ibge: "" });

export default function ServiceClients({ clients, reload }) {
  const [f, setF] = useState(null);
  const [editId, setEditId] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const buscaCep = async () => {
    const c = (f.cep || "").replace(/\D/g, "");
    if (c.length !== 8) return toast.error("Informe um CEP com 8 números.");
    try {
      const d = await (await fetch(`https://viacep.com.br/ws/${c}/json/`)).json();
      if (d.erro) throw new Error();
      setF((p) => ({ ...p, street: d.logradouro || p.street, district: d.bairro || p.district, city: d.localidade, uf: d.uf, ibge: d.ibge }));
    } catch { toast.error("CEP não encontrado. Preencha manualmente."); }
  };
  const save = async () => {
    if (!f.name.trim()) return toast.error("Informe o nome / razão social.");
    try {
      if (editId) await api.patch(`/service-clients/${editId}`, f); else await api.post("/service-clients", f);
      toast.success("Cliente salvo."); setF(null); setEditId(null); reload();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  const del = async (c) => { if (!window.confirm(`Excluir ${c.name}?`)) return; try { await api.delete(`/service-clients/${c.id}`); reload(); } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); } };

  return (
    <>
      {!f && <div style={{ marginBottom: 12 }}><button className="primary" onClick={() => { setF(empty()); setEditId(null); }} data-testid="client-new">＋ Novo cliente</button></div>}
      {f && (
        <article className="card" data-testid="client-form" style={{ marginBottom: 16 }}>
          <h2>{editId ? "Editar cliente" : "Novo cliente"}</h2>
          <div className="module-grid two-col">
            <label className="full-label">Nome / razão social<input value={f.name} onChange={set("name")} data-testid="client-name" /></label>
            <label className="full-label">Tipo<select value={f.kind} onChange={set("kind")} data-testid="client-kind">{KINDS.map((k) => <option key={k}>{k}</option>)}</select></label>
            <label className="full-label">CNPJ ou CPF<input value={f.doc} onChange={set("doc")} data-testid="client-doc" placeholder="Obrigatório para nota fiscal" /></label>
            <label className="full-label">E-mail<input value={f.email} onChange={set("email")} data-testid="client-email" /></label>
            <label className="full-label">Telefone / WhatsApp<input value={f.phone} onChange={set("phone")} data-testid="client-phone" /></label>
            <label className="full-label">CEP<div className="input-action"><input value={f.cep} maxLength={9} onChange={set("cep")} data-testid="client-cep" placeholder="00000-000" /><button onClick={buscaCep} data-testid="client-cep-search">Buscar</button></div></label>
            <label className="full-label">Rua<input value={f.street} onChange={set("street")} data-testid="client-street" /></label>
            <label className="full-label">Número<input value={f.number} onChange={set("number")} data-testid="client-number" /></label>
            <label className="full-label">Complemento<input value={f.complement} onChange={set("complement")} /></label>
            <label className="full-label">Bairro<input value={f.district} onChange={set("district")} data-testid="client-district" /></label>
            <label className="full-label">Cidade / UF<input value={[f.city, f.uf].filter(Boolean).join(" / ")} readOnly placeholder="Preenchido pelo CEP" data-testid="client-city" /></label>
          </div>
          <button className="primary" onClick={save} data-testid="client-save">Salvar cliente</button>
          <button className="secondary" style={{ marginLeft: 8 }} onClick={() => { setF(null); setEditId(null); }}>Cancelar</button>
        </article>
      )}
      <article className="card">
        <h2>Clientes cadastrados</h2>
        {clients.length === 0 ? <p className="hint">Cadastre hospitais, convênios, clínicas e outros clientes que contratam seus serviços.</p> : (
          <div className="module-list compact">
            {clients.map((c) => (
              <div className="list-card" key={c.id} data-testid={`client-${c.id}`}>
                <div><strong>{c.name}</strong><span>{c.kind}{c.doc ? ` • ${c.doc}` : " • sem CPF/CNPJ"}</span><small>{[c.city, c.uf].filter(Boolean).join(" / ")}{c.phone ? ` • ${c.phone}` : ""}</small></div>
                <div className="list-value">
                  <button onClick={() => { setF({ ...empty(), ...c }); setEditId(c.id); }} data-testid={`client-edit-${c.id}`}>Editar</button>
                  <button className="danger-lite" onClick={() => del(c)} data-testid={`client-delete-${c.id}`}>Excluir</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </article>
    </>
  );
}
